/**
 * The JSON wire format of bytes.
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 * e.g. "YWJjMTIzIT8kKiYoKSctPUB+"
 * JSON value will be the data encoded as a string using standard base64 encoding with paddings.
 * Either standard or URL-safe base64 encoding with/without paddings are accepted.
 */
export type bytes = string & { bytesBrand: 'brand' } | { bytesBrand: 'brand' };

export namespace bytes {
  export const nil = '' as bytes

  // Convert a string into encoded bytes.
  export function fromString(val: string): bytes {
    return btoa(val) as bytes
  }

  // Parse encoded bytes into a string. Returns empty string
  // if the input cannot be parsed.
  export function toString(val: bytes): string {
    if (!val) {
      return ''
    }
    try {
      return atob(val as string)
    } catch (e) {
      return ''
    }
  }
}
